import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { whatsappLink } from "../../lib/api";

const NAV = [
  { label: "Kurtas", href: "#kurtas" },
  { label: "Fabrics", href: "#fabrics" },
  { label: "Accessories", href: "#accessories" },
  { label: "Custom Tailoring", href: "#studio" },
  { label: "Visit Us", href: "#visit" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled ? "bg-cream/95 backdrop-blur-md border-charcoal/15" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex flex-col leading-none">
          <span className="font-display font-black text-2xl tracking-tight text-toga">TOGA</span>
          <span className="text-[8px] tracking-[0.3em] uppercase text-charcoal font-bold">Readymade & Custom-made</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.href.slice(1)}`}
              className="text-xs uppercase tracking-[0.15em] font-semibold text-charcoal hover:text-toga transition-colors duration-300"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={whatsappLink("Hello TOGA, I'd like to book an appointment.")}
            target="_blank"
            rel="noreferrer"
            data-testid="header-book-cta"
            className="hidden sm:inline-flex items-center bg-charcoal text-cream px-6 py-3 text-xs uppercase tracking-[0.15em] font-bold hover:bg-toga transition-colors duration-300"
          >
            Book Appointment
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-charcoal"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-cream border-t border-charcoal/15 px-6 py-6 flex flex-col gap-5">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-[0.15em] font-semibold text-charcoal"
            >
              {n.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
